<template>
  <div class="text-no-wrap" style="cursor: help; font-size: 0.85em;">
    <span
      :title="transc('booking.adults', booking.adults, {adults: booking.adults})"
    >
      {{ booking.adults }}<v-icon size="18" :color="color" style="margin-bottom: 4px;">mdi-account</v-icon>
    </span>
    <span
      v-if="booking.children"
      :title="transc('booking.children', booking.children, {children: booking.children})"
      class="ml-1"
    >
      {{ booking.children }}<v-icon size="15" :color="colorChildren" style="margin-bottom: 2px;">mdi-account</v-icon>
    </span>
  </div>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'BookingGuestsSummary',
  mixins: [
    LocaleUtils
  ],
  props: {
    /** @type BookingDto */
    booking: {
      type: Object,
      required: true
    },
    color: {
      default () {
        return '#878787';
      }
    },
    colorChildren: {
      default () {
        return '#878787';
      }
    }
  }
}
</script>

<style scoped>

</style>
